import { createModalsFactory } from 'ui';

type ChangePasswordModalIds = 'ChangePassword' | 'ResetPassword';

const { Provider: ChangePasswordModalProvider, useProvider: useChangePasswordModalProvider } =
  createModalsFactory<ChangePasswordModalIds[]>(['ChangePassword', 'ResetPassword']);

export { ChangePasswordModalProvider, useChangePasswordModalProvider };
